import { format } from "date-fns";
import { Download, Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { MyExpensesTab } from "./tabs/MyExpensesTab";
import { StatsSection } from "./sections/StatsSection";
import { ProfitComparisonSection } from "./sections/ProfitComparisonSection";
import { useOwnerCurrency } from "@/hooks/useOwnerCurrency";
import { StockAnalysisTab } from "./tabs/StockAnalysisTab";
import { useState, useEffect } from "react";
import { useIsMobile } from "@/hooks/use-mobile";
export const BudgetDashboard = () => {
  const {
    data: currency
  } = useOwnerCurrency();
  const isMobile = useIsMobile();
  const [activeTab, setActiveTab] = useState("dashboard");
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // Fermer le menu mobile lorsqu'on change d'onglet
  useEffect(() => {
    setIsMenuOpen(false);
  }, [activeTab]);
  const handleExportCSV = () => {
    const data = window.localStorage.getItem("transactions_summary");
    if (!data) return;
    const parsedData = JSON.parse(data);
    const headers = ["Date", "Montant"];
    const rows = parsedData.map((row: any) => [row.date, row.amount.toString()]);
    const csvContent = [headers.join(","), ...rows.map(row => row.join(","))].join("\n");
    const blob = new Blob([csvContent], {
      type: 'text/csv;charset=utf-8;'
    });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", `budget_${format(new Date(), 'yyyy-MM')}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const formatCurrency = (amount: number) => {
    return `${amount.toLocaleString()} ${currency || 'FCFA'}`;
  };
  const menuItems = [{
    id: "dashboard",
    label: "Tableau de bord"
  }, {
    id: "stock_analysis",
    label: "Rentabilité des produits"
  }, {
    id: "my_expenses",
    label: "Mes Dépenses"
  }];
  return <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h2 className="text-2xl font-bold">Tableau de bord financier</h2>
        {!isMobile && <Button onClick={handleExportCSV} variant="outline" size="sm">
            <Download className="w-4 h-4 mr-2" />
            Exporter CSV
          </Button>}
      </div>

      {/* Menu hamburger mobile */}
      {isMobile && <div className="relative mb-4">
          <Button variant="outline" size="sm" onClick={() => setIsMenuOpen(!isMenuOpen)} className="flex items-center gap-2 mb-2 font-medium text-lg bg-slate-300 hover:bg-slate-200">
            {isMenuOpen ? <X size={18} /> : <Menu size={18} />}
            <span>{menuItems.find(item => item.id === activeTab)?.label || "Menu"}</span>
          </Button>
          
          {/* Options du menu mobile */}
          {isMenuOpen && <div className="absolute z-50 top-full left-0 right-0 bg-white shadow-lg rounded-md border border-gray-200 py-2 mt-1">
              {menuItems.map(item => <button key={item.id} className={`w-full text-left px-4 py-2 hover:bg-gray-100 ${activeTab === item.id ? 'font-bold text-primary' : ''}`} onClick={() => {
          setActiveTab(item.id);
          setIsMenuOpen(false);
        }}>
                  {item.label}
                </button>)}
              <div className="border-t border-gray-200 mt-2 pt-2 px-4">
                <Button onClick={handleExportCSV} variant="outline" size="sm" className="w-full justify-start">
                  <Download className="w-4 h-4 mr-2" />
                  Exporter CSV
                </Button>
              </div>
            </div>}
        </div>}

      {/* Tabs pour la version desktop */}
      {!isMobile ? <Tabs defaultValue="dashboard" className="space-y-6">
          <TabsList className="bg-violet-300 hover:bg-violet-200">
            <TabsTrigger value="dashboard">Tableau de bord</TabsTrigger>
            <TabsTrigger value="stock_analysis">Rentabilité des produits</TabsTrigger>
            <TabsTrigger value="my_expenses" className="text-lg">Mes Dépenses</TabsTrigger>
          </TabsList>

          <TabsContent value="dashboard">
            <div className="space-y-6">
              <StatsSection formatCurrency={formatCurrency} />
              <ProfitComparisonSection formatCurrency={formatCurrency} />
            </div>
          </TabsContent>

          <TabsContent value="stock_analysis">
            <StockAnalysisTab />
          </TabsContent>

          <TabsContent value="my_expenses">
            <MyExpensesTab />
          </TabsContent>
        </Tabs> :
    // Contenu pour mobile selon l'onglet actif
    <div className="space-y-6">
          {activeTab === "dashboard" && <div className="space-y-6">
              <StatsSection formatCurrency={formatCurrency} />
              <ProfitComparisonSection formatCurrency={formatCurrency} />
            </div>}

          {activeTab === "stock_analysis" && <StockAnalysisTab />}

          {activeTab === "my_expenses" && <MyExpensesTab />}
        </div>}
    </div>;
};